import { ModifiedText, TextSearchData } from './types-store';

export const getModifiedText = (modifiedTexts: ModifiedText[], persistedText: TextSearchData) =>
  !modifiedTexts || !persistedText
    ? undefined
    : modifiedTexts.find(
      modifiedText => modifiedText.id === persistedText.id &&
        !!persistedText.textSet && persistedText.textSet.v === modifiedText.textSet &&
        !!persistedText.language && persistedText.language.v === modifiedText.language
    );

export const findModifiedText = (modifiedTexts: ModifiedText[], modifiedText: ModifiedText) =>
  !modifiedTexts || !modifiedText
    ? undefined
    : modifiedTexts.find(text =>
      text.id === modifiedText.id &&
      text.textSet === modifiedText.textSet &&
      text.language === modifiedText.language
    );

export const getPersistedText = (persistedTexts: TextSearchData[], modifiedText: ModifiedText) =>
  !persistedTexts || !modifiedText
    ? undefined
    : persistedTexts.find(
      persistedText => persistedText.id === modifiedText.id &&
        !!persistedText.textSet && persistedText.textSet.v === modifiedText.textSet &&
        !!persistedText.language && persistedText.language.v === modifiedText.language
    );

export const compareValueText = (persistedText: TextSearchData, modifiedText: ModifiedText): boolean =>
  modifiedText?.text === persistedText?.text;

export const updatePersistedTextValue = (persistedText: TextSearchData, modifiedText: ModifiedText): TextSearchData =>
  modifiedText
    ? {
      ...(persistedText || {} as TextSearchData),
      text: modifiedText.text?.trim()
    }
    : persistedText;
